import type { JSX } from 'react'
import type { ILabelGroupProps } from '../LabelGroup'

import { DolbyAtmosLabelIcon } from 'atoms/Icon/Templates'
import { QualityLabel } from 'atoms/Label/Templates'
import { FIXED_INDENTS } from 'vars/index'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate5Props extends ILabelGroupProps {
  quality?: string
  dolbyAtmos?: boolean
}

export const LabelGroupTemplate5 = ({
  columnGap = FIXED_INDENTS.INDENT_40,
  alignItems = 'center',
  quality,
  dolbyAtmos,
  ...rest
}: ILabelGroupTemplate5Props): JSX.Element => (
  <LabelGroup columnGap={columnGap} alignItems={alignItems} {...rest}>
    {quality && <QualityLabel title={quality} />}
    {dolbyAtmos && <DolbyAtmosLabelIcon />}
  </LabelGroup>
)
